module.exports = __webpack_public_path__ + "static/desktop-0ee209bd101862aa139da727ca5472f8.jpg";